'use strict';
const eventsFromEnvelope = require('./events-from-envelope');
module.exports = function GoldFileChangesEnvelopeBuilder(authenticationModel, sessionIdRetriever) {
	if (!authenticationModel || !sessionIdRetriever) {
		throw new Error('invalid-args');
	}
	let counter = 0;
	const self = this,
		sequenceId = () => {
			counter += 1;
			return counter;
		},
		buildGoldFileEnvelope = (description, timestamp, sessionId, sequence, events) => {
			const header = {description: description, ts: timestamp, sessionId: sessionId, sequence: sequence};
			return {header: header, events: events};
		},
		contentFromEvents = (events, sessionId, sequence, timestamp) => {
			return authenticationModel.getProfile()
			.then((profile) => buildGoldFileEnvelope(profile.description, timestamp, sessionId, sequence, events));
		};
	self.nextEnvelope = (events) => {
		const nextCounter = sequenceId();
		return contentFromEvents(events, sessionIdRetriever(), nextCounter, Date.now());
	};

	self.getCounter = () => counter;
	//TODO: make calls to this func dircect, it does not need to be here
	self.eventsFromEnvelope = eventsFromEnvelope;
};
